import React, { useState, useEffect } from 'react';
import styles from "./Myproject.module.css";
import { useOutletContext, Link } from 'react-router-dom';
import { getSharedProjects, respondToShareInvite } from '../../dashboardapi';
import { useToast, Spinner } from '@chakra-ui/react';

const Sharedproject = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const { ToogleSidebars } = useOutletContext();
    const toast = useToast();

    useEffect(() => {
        fetchSharedProjects();
    }, []);

    const fetchSharedProjects = async () => {
        setLoading(true);
        try {
            const result = await getSharedProjects();
            // result.data should contain the shares array
            if (result.data) {
                setProjects(result.data);
            } else if (result.error) {
                let errorMsg = "Failed to fetch shared projects";
                if (result.error && result.error.detail) errorMsg = result.error.detail;
                toast({
                    title: "Error",
                    description: errorMsg,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                setProjects([]);
            } else {
                setProjects([]);
            }
        } catch (error) {
            console.error("Error fetching shared projects:", error);
            toast({
                title: "Error fetching shared projects",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleResponse = async (shareId, action) => {
        try {
            const result = await respondToShareInvite(shareId, action);
            if (result.data) {
                toast({
                    title: `Invitation ${action}ed`,
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                fetchSharedProjects(); // Refresh list
            } else if (result.error) {
                toast({
                    title: `Error ${action}ing invitation`,
                    description: result.error.detail || result.error,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        } catch (error) {
            console.error(`Error ${action}ing invite:`, error);
            toast({
                title: `Error ${action}ing invitation`,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    console.log(projects);
    const filteredProjects = projects.filter((p) => {
        const projectName = p.project_name || "";
        return projectName.toLowerCase().includes(search.toLowerCase());
    });

    const pendingProjects = filteredProjects.filter(p => p.status === 'pending');
    const acceptedProjects = filteredProjects.filter(p => p.status === 'accepted');
    const declinedProjects = filteredProjects.filter(p => p.status === 'declined');
    return (
        <div className={styles.product_page_outer}>
            <div className={styles.indivprojectouter}>
                <div className={styles.project_heading}>
                    <div className={styles.dashboardSidebarIcon}>
                        <svg onClick={() => { if (window.innerWidth < 769) { ToogleSidebars(true) } }} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H9C9.55228 12 10 11.5523 10 11V4C10 3.44772 9.55228 3 9 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20 3H15C14.4477 3 14 3.44772 14 4V7C14 7.55228 14.4477 8 15 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20 12H15C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16Z" stroke="currentColo" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <p>Shared With You</p>
                    </div>
                </div>
                <div className={styles.Dashboardmaincontents}>
                    <div className={styles.dashboardsearchoption}>
                        <p>Projects</p>
                        <div className={styles.dashboardsearchfield}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 5.41667C0.75 6.0295 0.870707 6.63634 1.10523 7.20252C1.33975 7.76871 1.68349 8.28316 2.11683 8.7165C2.55017 9.14984 3.06462 9.49358 3.63081 9.7281C4.197 9.96263 4.80383 10.0833 5.41667 10.0833C6.0295 10.0833 6.63634 9.96263 7.20252 9.7281C7.76871 9.49358 8.28316 9.14984 8.7165 8.7165C9.14984 8.28316 9.49358 7.76871 9.7281 7.20252C9.96263 6.63634 10.0833 6.0295 10.0833 5.41667C10.0833 4.80383 9.96263 4.197 9.7281 3.63081C9.49358 3.06462 9.14984 2.55017 8.7165 2.11683C8.28316 1.68349 7.76871 1.33975 7.20252 1.10523C6.63634 0.870707 6.0295 0.75 5.41667 0.75C4.80383 0.75 4.197 0.870707 3.63081 1.10523C3.06462 1.33975 2.55017 1.68349 2.11683 2.11683C1.68349 2.55017 1.33975 3.06462 1.10523 3.63081C0.870707 4.197 0.75 4.80383 0.75 5.41667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12.75 12.75L8.75 8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <input
                                type='text'
                                placeholder='Search Shared Projects'
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={styles.indivprojectlist}>
                        {loading ? (
                            <div className={styles.Nocontent}>
                                <Spinner />
                            </div>
                        ) : filteredProjects.length === 0 ? (
                            <div className={styles.Nocontent}>
                                <p>No shared projects found.</p>
                            </div>
                        ) : (
                            <>
                                {pendingProjects.length > 0 && (
                                    <>
                                        <h3 style={{ marginLeft: '10px', marginTop: '10px' }}>Pending Invites ({pendingProjects.length})</h3>
                                        {pendingProjects.map((item, i) => (
                                            <div key={'pending-' + i} className={styles.indivproject}>
                                                <div className={styles.projectContainer}>
                                                    <div className={styles.nameContainer}>
                                                        <div className={styles.dashboardfileicons}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>
                                                        </div>
                                                        <div className={styles.nameanddatecontainer}>
                                                            <h2>{item.project_name}</h2>
                                                            <div className={styles.dateandproject}>
                                                                <p>Owner: {item.owner_email}</p>
                                                                <p style={{ color: "#f26722" }}>Status: Pending</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={styles.dashboardoptions}>
                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                            <button
                                                                onClick={() => handleResponse(item.share_id, 'accept')}
                                                                style={{ padding: '6px 12px', backgroundColor: 'green', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                                            >
                                                                Accept
                                                            </button>
                                                            <button
                                                                onClick={() => handleResponse(item.share_id, 'decline')}
                                                                style={{ padding: '6px 12px', backgroundColor: '#AD0000', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                                            >
                                                                Decline
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}

                                {acceptedProjects.length > 0 && (
                                    <>
                                        {/* {pendingProjects.length > 0 && <hr style={{ margin: '20px 0', borderColor: '#eee' }} />} */}
                                        <h3 style={{ marginLeft: '10px', marginTop: '10px', color: '#666' }}>Accepted Projects</h3>
                                        {acceptedProjects.map((item, i) => (
                                            <div key={'accepted-' + i} className={styles.indivproject}>
                                                <div className={styles.projectContainer}>
                                                    <div className={styles.nameContainer}>
                                                        <div className={styles.dashboardfileicons}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>
                                                        </div>
                                                        <div className={styles.nameanddatecontainer}>
                                                            <h2>{item.project_name}</h2>
                                                            <div className={styles.dateandproject}>
                                                                <p>Owner: {item.owner_email}</p>
                                                                <p>Permission: {item.permission}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={styles.dashboardoptions}>
                                                        <Link to={`/${item.project_id}/`}>
                                                            Open in editor
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}


                                {declinedProjects.length > 0 && (
                                    <>
                                        {/* {pendingProjects.length > 0 && <hr style={{ margin: '20px 0', borderColor: '#eee' }} />} */}
                                        <h3 style={{ marginLeft: '10px', marginTop: '10px', color: '#666' }}>Declined Projects</h3>
                                        {declinedProjects.map((item, i) => (
                                            <div key={'accepted-' + i} className={styles.indivproject}>
                                                <div className={styles.projectContainer}>
                                                    <div className={styles.nameContainer}>
                                                        <div className={styles.dashboardfileicons}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>
                                                        </div>
                                                        <div className={styles.nameanddatecontainer}>
                                                            <h2>{item.project_name}</h2>
                                                            <div className={styles.dateandproject}>
                                                                <p>Owner: {item.owner_email}</p>
                                                                <p>Permission: {item.permission}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={styles.dashboardoptions}>
                                                        <Link to={`/${item.project_id}/`}>
                                                            Open in editor
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sharedproject;